import React, { useState } from 'react';
import './style.scss';

const AccordionItem = ({ title, children, isOpenByDefault, isOpen, onAccordionClick }) => {
  const toggleAccordion = () => {
    if (onAccordionClick) {
      onAccordionClick();
    }
  };

  return (
    <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
      <div className={`accordion-title ${isOpen ? 'active' : 'notActive'}`} onClick={toggleAccordion}>
        <h2>{title}</h2>
        <span className={`accordion-icon ${isOpen ? 'open' : ''}`}>
          <i className={`fa fa-${isOpen ? 'minus' : 'plus'} faq-icon`}></i>
        </span>
      </div>
      <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default AccordionItem;
